import { PersonalizationVariable } from '@/lib/types/personalization-variable';

export const PERSONALIZATION_VARIABLES: PersonalizationVariable[] = [
  { key: 'firstName', label: 'First name', placeholder: '{{firstName}}' },
  { key: 'lastName', label: 'Last name', placeholder: '{{lastName}}' },
  { key: 'email', label: 'Email', placeholder: '{{email}}' },
  { key: 'company', label: 'Company', placeholder: '{{company}}' },
  { key: 'linkedinUrl', label: 'LinkedIn URL', placeholder: '{{linkedinUrl}}' },
  { key: 'senderFirstName', label: 'Sender first name', placeholder: '{{senderFirstName}}' },
  { key: 'senderLastName', label: 'Sender last name', placeholder: '{{senderLastName}}' },
];
